export default __webpack_public_path__ + "src/images/packages/safari-moon-lodge/080756aca9e75825cf78d9e5ed43b7f1-3.jpg";